<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Grupos</span>
      </v-row>

      <!-- LISTAGEM -->
      <v-row>
        <v-col cols="12" sm="12" md="9">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum grupo cadastrado"
              hide-default-footer
              :headers="cabecalho"
              :items="formData"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
            >
              <template v-slot:item.modulos="{ item }">
                <v-chip
                  v-for="(m,index) in item.modulos"
                  :key="index"
                  small
                  class="ma-1"
                >{{m.modulo.modulo_nome}}</v-chip>
              </template>

              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>

                <v-tooltip top color="black" v-if="item.grupo_fixo && editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Não é possível
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span> grupos fixos
                  </span>
                </v-tooltip>

                <v-menu offset-x v-if="!item.grupo_fixo && editModulo">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                  >Mostrar menos</v-btn>
                  <v-btn
                    v-if="formData.length > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                  >Carregar mais</v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda" v-if="editModulo">
              <v-col class="mr-8">
                <v-btn
                  @click="novaEntidade()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480  !important;"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1">mdi-account-multiple-plus</v-icon>
                  <span class="white--text">Novo grupo</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIALOG CADASTRAR/EDITAR -->
    <v-dialog v-model="dialog_edit_grupo" scrollable persistent width="900px">
      <v-form ref="form2" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            <span v-if="novo_grupo.id_grupo">Editar grupo</span>
            <span v-else>Novo grupo</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="mb-n5">
                <span class="font-weight-bold black--text">Nome *</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="novo_grupo.grupo_nome"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <span class="black--text font-weight-bold">Módulos de acesso *</span>
                <v-select
                  class="mb-n7"
                  solo
                  dense
                  flat
                  required
                  :rules="requiredRules"
                  item-color="#283480"
                  outlined
                  :items="modulos"
                  item-value="id_modulo"
                  item-text="modulo_nome"
                  v-model="novo_grupo.modulos"
                  @input="addPermissoes()"
                  :multiple="true"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="novo_grupo.permissoes.length > 0">
              <v-col>
                <v-data-table
                  hide-default-footer
                  :headers="[{text: 'Módulo', sortable: false, value: 'id'},{text: 'Permissão', align: 'center',sortable: false, value: 'editar'}]"
                  :items="novo_grupo.permissoes"
                  :items-per-page="10000"
                >
                  <!-- novo_grupo.nomes -->
                  <template v-slot:item.id="{ item }">
                    <v-row justify="center">
                      <v-col>
                        <span v-text="nomes(item)"></span>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:item.editar="{ item }">
                    <v-row justify="center">
                      <v-switch
                        v-if="item.editar == 0"
                        v-model="item.editar"
                        label="Apenas visualização"
                      ></v-switch>
                      <v-switch v-else v-model="item.editar" label="Visualizar e editar"></v-switch>
                    </v-row>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG EXCLUIR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este grupo?</v-card-title>
        <v-card-text>Se deletar este grupo ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      loading: "false",
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" }
      ],
      menu1: false,
      menu2: false,
      dialog_edit_grupo: false,
      dialog_delete: false,
      formData: [],
      modulos: [],
      valid: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      cabecalho: [
        { text: "Nome", align: "start", value: "grupo_nome" },
        { text: "Módulos", align: "center", value: "modulos", width: "60%" },
        { text: "Ações", align: "end", sortable: false, value: "acao" }
      ],
      editModulo: false,
      novo_grupo: {
        grupo_nome: "",
        modulos: [],
        permissoes: [],
        nomes: []
      }
    };
  },
  computed: {},
  created() {
    this.getGrupo();
    this.getModulos();
    this.validaEdicaoModulo();
  },
  methods: {
    nomes(item) {
      let ret = this.novo_grupo.permissoes.indexOf(item);
      return this.novo_grupo.nomes[ret];
    },
    addPermissoes() {
      let edit = [];
      for (let i = 0; i < this.novo_grupo.permissoes.length; i++) {
        edit.push(this.novo_grupo.permissoes[i].editar);
      }

      this.novo_grupo.permissoes = [];
      this.novo_grupo.nomes = [];

      for (let i = 0; i < this.novo_grupo.modulos.length; i++) {
        this.novo_grupo.permissoes.push({
          id: this.novo_grupo.modulos[i],
          editar: edit[i] == true ? true : false
        });
        for (let j = 0; j < this.modulos.length; j++) {
          if (this.novo_grupo.permissoes[i].id == this.modulos[j].id_modulo) {
            this.novo_grupo.nomes.push(this.modulos[j].modulo_nome);
          }
        }
      }
    },
    deleteItem() {
      this.loading = true;
      Api.delete(`/grupos/` + this.formData.id_grupo)
        .then(response => {
          if (response) {
            this.loading = false;
          }
          this.formData.id_grupo = "";
          this.getGrupo();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },

    menu(opcao, item) {
      this.formData.id_grupo = item.id_grupo;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.novo_grupo = {
          grupo_nome: item.grupo_nome,
          modulos: [],
          permissoes: [],
          nomes: [],
          id_grupo: item.id_grupo
        };
        for (let i = 0; i < item.modulos.length; i++) {
          this.novo_grupo.modulos.push(item.modulos[i].fk_id_modulo);

          this.novo_grupo.permissoes.push({
            id: item.modulos[i].fk_id_modulo,
            editar: item.modulos[i].editar
          });
          for (let j = 0; j < this.modulos.length; j++) {
            if (this.novo_grupo.permissoes[i].id == this.modulos[j].id_modulo) {
              this.novo_grupo.nomes.push(this.modulos[j].modulo_nome);
            }
          }
        }

        this.dialog_edit_grupo = true;
      }
    },
    save() {
      this.loading = true;
      if (this.$refs.form2.validate()) {
        this.loading = true;
        for (let i = 0; i < this.novo_grupo.permissoes.length; i++) {
          if (this.novo_grupo.permissoes[i].editar == true) {
            this.novo_grupo.permissoes[i].editar = 1;
          } else {
            this.novo_grupo.permissoes[i].editar = 0;
          }
        }
        let rota = "";
        if (this.novo_grupo.id_grupo) {
          rota = "/" + this.novo_grupo.id_grupo;
        }
        Api.post("/grupos" + rota, this.novo_grupo)
          .then(response => {
            if (response) {
              this.loading = false;
              if (this.novo_grupo.id_grupo) {
                this.$toast.success("Editado com sucesso!");
              } else {
                this.$toast.success("Cadastrado com sucesso!");
              }
              this.getGrupo();
              this.$refs.form2.resetValidation();
              this.close();
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    getGrupo() {
      this.loading = true;
      Api.get(`/grupos`)
        .then(response => {
          if (response.data.data) {
            this.formData = response.data.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    getModulos() {
      this.loading = true;
      Api.get(`/modulos`)
        .then(response => {
          if (response.data.data) {
            this.modulos = response.data.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    carregarMais() {
      if (this.formData.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },
    close() {
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
      this.dialog_edit_grupo = false;
      this.novo_grupo = {
        grupo_nome: "",
        modulos: [],
        permissoes: [],
        nomes: []
      };
    },
    novaEntidade() {
      this.dialog_edit_grupo = true;
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>